import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Tabs from '../views/Tabs.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Tabs,
    children: [
      {
        path: '',
        redirect: '/collections'
      },
      {
        path: 'nfts',
        component: () => import('@/pages/nfts.vue')
      },
      {
        path: 'collections',
        component: () => import('@/pages/collections.vue')
      },
      {
        path: 'accounts',
        component: () => import('@/pages/accounts.vue')
      },
      {
        path: 'pending',
        component: () => import('@/pages/pending.vue')
      },
      {
        path: 'notifications',
        component: () => import('@/pages/notifications.vue')
      },
      {
        path: 'settings',
        component: () => import('@/pages/settings.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
